import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { BROCHURE_BUTTON_TEXT } from '../utils/conversationFlow';

import tgai from '../TourGuideAi.module.scss';

// The brochure button, styled like the welcome form's submit. It grows taller
// and wraps centered, like the other chat buttons.
const BrochureLinkField = ({ url }) => (
  <a
    className={cx(tgai.btn, tgai.primary, tgai.fit)}
    href={url}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="tgai-button:view_brochure"
    data-tgai-button=""
    data-action="view_brochure"
  >
    <span className={tgai.fitLabel} style={{ '--chars': BROCHURE_BUTTON_TEXT.length }}>
      {BROCHURE_BUTTON_TEXT}
    </span>
  </a>
);

BrochureLinkField.propTypes = {
  url: PropTypes.string.isRequired,
};

export default BrochureLinkField;
